// Amplify
import { Auth } from 'aws-amplify';

export const getSessionEmail = async (): Promise<string> => {
  const session = await Auth.currentSession();
  const { email } = session.getIdToken().payload;
  return email;
};
